import { Config } from '../config/IISMethods'

const initialState = {
    data: [],
    // For traveldesk approving persons. Right now it will store all the login data. Will get modified moving forward
    loginData: {},
    fieldOrder: [],
    newFieldOrder: [],
    pagelimit: 20,
    wpchatpagelimit: 20,
    pageNo: 1,
    wpchatpageNo: 1,
    nextpage: 1,
    wpchatnextpage: 1,
    ApplicationNextPage: 1,
    applicationmodalPageNo: 1,
    pageName: '',
    subPageName: '',
    //For activitytrackertab
    activetrackertab: '',
    sortData: {},
    formData: {},
    wpchatformData: {},
    childFormData: {},
    childMasterData: {},//priyanshi for child form masterdata
    childMasterDataList: {},//priyanshi for child form masterdata
    placeholderFormData: {},
    changePasswordFormData: {},
    passwordresetModal: {},
    childRightSidebarFormData: {},
    masterFormData: {},
    filterData: {},
    oldFilterData: {},
    rightSidebarFormData: [],
    wpchatrightSidebarFormData: [],
    masterRightSidebarFormData: [],
    fieldobjectformasterdata: {},
    rightSidebarShimmer: false,
    masterData: {},
    masterDataList: {},
    modal: {},

    // start ~ use this variable only for quickaccess --> create task, log regularize and clockin-clockout | Nirzar Gabani 💀 ~  2024-11-20 ~ 12:57 PM
    quickAccessData: [],
    quickAccessFieldOrder: [],
    quickAccessRightSidebarFormData: [],
    quickAccessTimerdata: [],
    quickAccessNextpage: 1,
    quickAccessFormData: {},
    quickAccessMasterData: {},
    quickAccessMasterDataList: {},
    quickAccessFilterData: {},
    // end ~ use this variable only for quickaccess --> create task, log regularize and clockin-clockout | Nirzar Gabani 💀 ~  2024-11-20 ~ 12:57 PM

    timerdata: [],
    timerpageNo: 1,

    searchValue: '',
    searchResultArray: [],
    documentData: [],
    menuData: [],
    seriesOrder: [],
    applicationData: [],
    secondarySourceMasterData: '',
    candidateRightSidebarFormData: [],
    supportTicketRightSidebarFormData: [],
    candidateFormData: {},
    currentOpening: '',
    currentCandidate: {},
    currentApplication: {},
    listOfCandidates: [],
    otherOpeningsData: {},

    // whatsapp integration
    usersList: [],
    currentCandidateChat: [],
    chatUploadingFilesStatus: [],

    //followup
    followupFormData: {},
    followupRightSidebarFormData: [],
    netxStageFromData: {},
    orgChartData: {},
    editedJoiningStage: {},
    stages: [],
    currentStageIndex: 0,
    editedQuestionData: {},
    loginresp: {},
    // ApplicationBasicInfo : [],
    // FollowupModalData : [],
    momFormData: {},

    // API Manager
    APIRequestList: [],

    //ENV List
    envdata: [],

    // for loader
    loading: 0,
    loadings: {},

    //crm contact 
    contactRightSidebarFormData: [],
    contactFormData: {},
    //crm lead 
    leadRightSidebarFormData: [],
    leadFormData: {},

    // Performance Review Response
    performanceReviewFormData: {},

    //Manager Review
    managerReviewFormData: {},

    //Manager Review From Home
    homePendingSurveyFormData: {},
    pendingSyrveyNextPage: 1,

    // Notification:
    notifications: [],
    notificationLimit: 10,
    notificationPageNo: 1,
    notificationNextpage: 1,
    notificationCount: 0,

    //Recruitment Notification
    recruitmentNotification: [],
    recruitmentNotificationLimit: 10,
    recruitmentNotificationPageNo: 1,
    recruitmentNotificationNextpage: 1,
    recruitmentNotificationCount: 0,

    //Global Search
    searchItems: [],

    //from notification to opening
    redirectPagename: "",
    redirectItem: {},
    redirectFromNotification: 0,

    // reapproach
    reapproach: 0,

    //global search
    searchCandidate: [],
    announcements: [],

    // disableButton : false

    // cookieData
    cookiesData: {},
    // localStorageData
    localStorageData: {},
    // hemang 9/1/22
    renderSubheaderRouter: false,
    // harsh 17-1-2023
    headerAnnouncement: [],
    // harsh 26-4-2023
    headerModal: {},

    //AI Question Generator
    aiQuestionGeneratorRightSidebarFormData: [],
    aiMasterData: {},
    aiMasterDataList: {},
    aiFormData: {},
    aiData: [],
    aiSortData: {},
    aiFieldOrder: [],
    aiFilterData: {},
    // Project
    globalTimer: {}, // juhil - 5-5-2023,
    globalTimerCompleteData: {}, //for complete task from floating timer

    //Vacant Seat
    vacentSeatData: [],
    vacentSeatRightSidebarFormData: [],
    vacentSeatFilterData: {},
    vacentSeatFormData: {},


    userRights: [],
    widgetRights: [], // do not stage ~ Nirzar Gabani
    menuData: [],
    aliasData: [], // for storing all available alias
    supportRating: {},
    assetAssign: {},
    errorBatch: [], // for storing all errors ~ Utsav

    deleteModalData: {},//for delete modal
    taskNotes: {},//for notes in task and todo
    taskComments: {},//for comments in support

    //for bulk action
    bulkactionalias: '',
    bulkactiondata: [],
    approvalbulkactiondata: {}, // for Approval in Bulk Action | Deep Dungarani  ~ 2025-11-04


    // for emp 360 -> Document feature -> downloads and uploads ~ Utsav
    fileuploads: [],
    filedownloads: [],

    selectedNodeIndex: '',

    bizSupportTicketRightSidebarFormData: [],

    // for detail modal data --grids
    detailModalData: [],
    detailModalFieldOrder:[], 
    detailModalNewFieldOrder: [],
    detailModalNextpage: 0,
    detailModalPageNo: 1,
    detailModalPagelimit: 20,
    detailModalPageName: '',
    detailsModalFromData: {},
    detailModalSortData: {},
    detailModalFilterData: {},
    detailModalOldFilterData: {},
    detailModalMasterData: {},
    detailModalMasterDataList: {},
    tagValidationsModal: {}, // for inputfield tag validations smit surani  ~ 2025-06-30 ~ 12:38 PM

    // bizcompass configuration
    bizConfigData: [],
    redirectFromConfigration: {
        redirect: 0,// 1 - redirected , 2 - back press  
        configRedirection: [],
        url:''
    },

    // do not change
    //*************************************** Secret Keys Start ****************************************/ 
    REACT_APP_SECRETKEY: 'vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3', //for get access tocken
    REACT_APP_KEY: 'Bizcompass_98F2B6E0-240A-457B-853A-A0079862315F', //for encryption
    REACT_APP_ISSUER: 'website',
    REACT_APP_PLATFORM: 1,
    REACT_APP_METHOD_GET: 'GET',
    REACT_APP_METHOD_POST: 'POST',
    REACT_APP_METHOD_DEL: 'DELETE',
    REACT_APP_REQ_LIST: '',
    REACT_APP_REQ_ADD: 'add',
    REACT_APP_REQ_UPDATE: 'update',
    REACT_APP_REQ_DELETE: 'delete',
    META_CLIENTID: '',
    ZOOM_CLIENT_ID: '', //Aniket 21/04/2025
    GOOGLE_CLIENT_ID: '', //Aniket 21/04/2025
    MICROSOFT_CLIENT_ID : '', //Aniket 01/05/2025
    MICROSOFT_TENANT_ID : '', //Aniket 01/05/2025
    WP_CLIENTID: '',
    WP_CONFIGID: '',
    META_CLIENTSECRET: '',
    GOOGLE_MAP_API_KEY: 'AIzaSyAoZh2I_fXtGM2GNi26dFbmFHpdIB1aEh8',
    GOOGLE_FONTS_API_KEY: '',
    // DO NOT STAGE THIS CHANGE
    // RE_CAPTCHA_SITE_KEY: '6Lc9GDEpAAAAAKpzV6PVm6rRKeo7xGK8koXWJfro', //FOR reCAPTCHA v3 -- google account --> bizcompasspostman2022@gmail.com
    RE_CAPTCHA_SITE_KEY: (Config.getServermode() == 'prod') ? '6LdTU_4qAAAAABzzl0yy2JJvAinOTmOdIVa4k1MP' : '6Lc955EqAAAAALP3dEcMzYstXHb7ZIPRo_JSC-KE', //FOR reCAPTCHA v2 PROD --> bizcompassai@gmail.com  || UAT -- google account --> bizcompasspostman2022@gmail.com
    // RE_CAPTCHA_SITE_KEY: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI', //FOR reCAPTCHA testing in local enviroment  -- google account --> bizcompasspostman2022@gmail.com
    //*************************************** Secret Keys End ****************************************/ 

    envConfig: {}, // For env credencial

    //************************************* AWS Cognito Credentials Start *************************************
    // for live
    // POOL_NAME : 'bizcompass_react',
    // POOL_PASS : 'Asd@123!@#',
    // USER_POOL_ID : "us-east-1_9wd50z9ge",
    // POOL_CLIENT_ID : '2hptp1b8v23u956u07t7m8i167' ,
    // IDENTITY_POOL_ID : 'us-east-1:137d1c33-8a04-41ac-b128-12625c37f357',
    // S3_BUCKET_NAME : 'bizcompass'

    // for uat and local
    POOL_NAME: Config.POOL_NAME,
    POOL_PASS: Config.POOL_PASS,
    USER_POOL_ID: Config.USER_POOL_ID,
    POOL_CLIENT_ID: Config.POOL_CLIENT_ID,
    IDENTITY_POOL_ID: Config.IDENTITY_POOL_ID,
    S3_BUCKET_NAME: Config.S3_BUCKET_NAME

    //************************************* AWS Cognito Credentials End *************************************

}

const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'setProps':
            return {
                ...state,
                pageName: (action.payload.pageName !== undefined ? action.payload.pageName : state.pageName),
                activetrackertab: (action.payload.activetrackertab !== undefined ? action.payload.activetrackertab : state.activetrackertab),
                subPageName: (action.payload.subPageName !== undefined ? action.payload.subPageName : state.subPageName),
                pageNo: (action.payload.pageNo !== undefined ? action.payload.pageNo : state.pageNo),
                wpchatpageNo: (action.payload.wpchatpageNo !== undefined ? action.payload.wpchatpageNo : state.wpchatpageNo),
                applicationmodalPageNo: (action.payload.applicationmodalPageNo !== undefined ? action.payload.applicationmodalPageNo : state.applicationmodalPageNo),
                pagelimit: (action.payload.pagelimit !== undefined ? action.payload.pagelimit : state.pagelimit),
                wpchatpagelimit: (action.payload.wpchatpagelimit !== undefined ? action.payload.wpchatpagelimit : state.wpchatpagelimit),
                data: (action.payload.data !== undefined ? state.data.concat(action.payload.data) : state.data),
                quickAccessData: (action.payload.quickAccessData !== undefined ? state.quickAccessData.concat(action.payload.quickAccessData) : state.quickAccessData),
                nextpage: (action.payload.nextpage !== undefined ? action.payload.nextpage : state.nextpage),
                wpchatnextpage: (action.payload.wpchatnextpage !== undefined ? action.payload.wpchatnextpage : state.wpchatnextpage),
                quickAccessNextpage: (action.payload.quickAccessNextpage !== undefined ? action.payload.quickAccessNextpage : state.quickAccessNextpage),
                ApplicationNextPage: (action.payload.ApplicationNextPage !== undefined ? action.payload.ApplicationNextPage : state.ApplicationNextPage),
                sortData: (action.payload.sortData !== undefined ? action.payload.sortData : state.sortData),
                loginData: (action.payload.loginData !== undefined ? action.payload.loginData : state.loginData),
                fieldOrder: (action.payload.fieldOrder !== undefined ? action.payload.fieldOrder : state.fieldOrder),
                quickAccessFieldOrder: (action.payload.quickAccessFieldOrder !== undefined ? action.payload.quickAccessFieldOrder : state.quickAccessFieldOrder),
                newFieldOrder: (action.payload.newFieldOrder !== undefined ? action.payload.newFieldOrder : state.newFieldOrder),
                formData: (action.payload.formData !== undefined ? action.payload.formData : state.formData),
                wpchatformData: (action.payload.wpchatformData !== undefined ? action.payload.wpchatformData : state.wpchatformData),
                quickAccessFormData: (action.payload.quickAccessFormData !== undefined ? action.payload.quickAccessFormData : state.quickAccessFormData),
                childFormData: (action.payload.childFormData !== undefined ? action.payload.childFormData : state.childFormData),
                detailsModalFromData: (action.payload.detailsModalFromData !== undefined ? action.payload.detailsModalFromData : state.detailsModalFromData),
                placeholderFormData: (action.payload.placeholderFormData !== undefined ? action.payload.placeholderFormData : state.placeholderFormData),
                changePasswordFormData: (action.payload.changePasswordFormData !== undefined ? action.payload.changePasswordFormData : state.changePasswordFormData),
                passwordresetModal: (action.payload.passwordresetModal !== undefined ? action.payload.passwordresetModal : state.passwordresetModal),
                childRightSidebarFormData: (action.payload.childRightSidebarFormData !== undefined ? action.payload.childRightSidebarFormData : state.childRightSidebarFormData),
                loginresp: (action.payload.loginresp !== undefined ? action.payload.loginresp : state.loginresp),
                masterFormData: (action.payload.masterFormData !== undefined ? action.payload.masterFormData : state.masterFormData),
                filterData: (action.payload.filterData !== undefined ? action.payload.filterData : state.filterData),
                quickAccessFilterData: (action.payload.quickAccessFilterData !== undefined ? action.payload.quickAccessFilterData : state.quickAccessFilterData),
                oldFilterData: (action.payload.oldFilterData !== undefined ? action.payload.oldFilterData : state.oldFilterData),
                rightSidebarFormData: (action.payload.rightSidebarFormData !== undefined ? action.payload.rightSidebarFormData : state.rightSidebarFormData),
                wpchatrightSidebarFormData: (action.payload.wpchatrightSidebarFormData !== undefined ? action.payload.wpchatrightSidebarFormData : state.wpchatrightSidebarFormData),
                quickAccessRightSidebarFormData: (action.payload.quickAccessRightSidebarFormData !== undefined ? action.payload.quickAccessRightSidebarFormData : state.quickAccessRightSidebarFormData),
                masterRightSidebarFormData: (action.payload.masterRightSidebarFormData !== undefined ? action.payload.masterRightSidebarFormData : state.masterRightSidebarFormData),
                fieldobjectformasterdata: (action.payload.fieldobjectformasterdata !== undefined ? action.payload.fieldobjectformasterdata : state.fieldobjectformasterdata),
                rightSidebarShimmer: (action.payload.rightSidebarShimmer !== undefined ? action.payload.rightSidebarShimmer : state.rightSidebarShimmer),
                masterData: (action.payload.masterData !== undefined) ? action.payload.masterData : state.masterData,
                masterDataList: (action.payload.masterDataList !== undefined) ? action.payload.masterDataList : state.masterDataList,
                modal: (action.payload.modal !== undefined) ? action.payload.modal : state.modal,

                quickAccessMasterData: (action.payload.quickAccessMasterData !== undefined) ? action.payload.quickAccessMasterData : state.quickAccessMasterData,
                quickAccessMasterDataList: (action.payload.quickAccessMasterDataList !== undefined) ? action.payload.quickAccessMasterDataList : state.quickAccessMasterDataList,

                childMasterDataList: (action.payload.childMasterDataList !== undefined) ? action.payload.childMasterDataList : state.childMasterDataList,
                childMasterData: (action.payload.childMasterData !== undefined) ? action.payload.childMasterData : state.childMasterData,

                timerpageNo: (action.payload.timerpageNo !== undefined ? action.payload.timerpageNo : state.timerpageNo),
                timerdata: (action.payload.timerdata !== undefined ? action.payload.timerdata : state.timerdata),
                quickAccessTimerdata: (action.payload.quickAccessTimerdata !== undefined ? action.payload.quickAccessTimerdata : state.quickAccessTimerdata),

                applicationData: (action.payload.applicationData !== undefined ? state.applicationData.concat(action.payload.applicationData) : state.applicationData),
                menuData: (action.payload.menuData !== undefined ? action.payload.menuData : state.menuData),
                searchValue: (action.payload.searchValue !== undefined) ? action.payload.searchValue : state.searchValue,
                documentData: (action.payload.documentData !== undefined) ? action.payload.documentData : state.documentData,
                seriesOrder: (action.payload.seriesOrder !== undefined ? action.payload.seriesOrder : state.seriesOrder),


                aiQuestionGeneratorRightSidebarFormData: (action.payload.aiQuestionGeneratorRightSidebarFormData !== undefined ? action.payload.aiQuestionGeneratorRightSidebarFormData : state.aiQuestionGeneratorRightSidebarFormData),
                aiMasterData: (action.payload.aiMasterData !== undefined) ? action.payload.aiMasterData : state.aiMasterData,
                aiMasterDataList: (action.payload.aiMasterDataList !== undefined) ? action.payload.aiMasterDataList : state.aiMasterDataList,
                aiFormData: (action.payload.aiFormData !== undefined ? action.payload.aiFormData : state.aiFormData),
                aiData: (action.payload.aiData !== undefined ? action.payload.aiData : state.aiData),
                aiFieldOrder: (action.payload.aiFieldOrder !== undefined ? action.payload.aiFieldOrder : state.aiFieldOrder),
                aiSortData: (action.payload.aiSortData !== undefined ? action.payload.aiSortData : state.aiSortData),
                aiFilterData: (action.payload.aiFilterData !== undefined ? action.payload.aiFilterData : state.aiFilterData),


                secondarySourceMasterData: (action.payload.secondarySourceMasterData !== undefined ? action.payload.secondarySourceMasterData : state.secondarySourceMasterData),
                candidateRightSidebarFormData: (action.payload.candidateRightSidebarFormData !== undefined ? action.payload.candidateRightSidebarFormData : state.candidateRightSidebarFormData),
                contactRightSidebarFormData: (action.payload.contactRightSidebarFormData !== undefined ? action.payload.contactRightSidebarFormData : state.contactRightSidebarFormData),
                contactFormData: (action.payload.contactFormData !== undefined ? action.payload.contactFormData : state.contactFormData),
                leadRightSidebarFormData: (action.payload.leadRightSidebarFormData !== undefined ? action.payload.leadRightSidebarFormData : state.leadRightSidebarFormData),
                followupRightSidebarFormData: (action.payload.followupRightSidebarFormData !== undefined ? action.payload.followupRightSidebarFormData : state.followupRightSidebarFormData),
                leadFormData: (action.payload.leadFormData !== undefined ? action.payload.leadFormData : state.leadFormData),
                supportTicketRightSidebarFormData: (action.payload.supportTicketRightSidebarFormData !== undefined ? action.payload.supportTicketRightSidebarFormData : state.supportTicketRightSidebarFormData),
                bizSupportTicketRightSidebarFormData: (action.payload.bizSupportTicketRightSidebarFormData !== undefined ? action.payload.bizSupportTicketRightSidebarFormData : state.bizSupportTicketRightSidebarFormData),

                performanceReviewFormData: (action.payload.performanceReviewFormData !== undefined ? action.payload.performanceReviewFormData : state.performanceReviewFormData),
                managerReviewFormData: (action.payload.managerReviewFormData !== undefined ? action.payload.managerReviewFormData : state.managerReviewFormData),
                homePendingSurveyFormData: (action.payload.homePendingSurveyFormData !== undefined ? action.payload.homePendingSurveyFormData : state.homePendingSurveyFormData),
                pendingSyrveyNextPage: (action.payload.pendingSyrveyNextPage !== undefined ? action.payload.pendingSyrveyNextPage : state.pendingSyrveyNextPage),
                // ApplicationBasicInfo : (action.payload.ApplicationBasicInfo !== undefined ? action.payload.ApplicationBasicInfo : state.ApplicationBasicInfo),
                // FollowupModalData : (action.payload.FollowupModalData !== undefined ? action.payload.FollowupModalData : state.FollowupModalData),
                candidateFormData: (action.payload.candidateFormData !== undefined ? action.payload.candidateFormData : state.candidateFormData),
                currentOpening: (action.payload.currentOpening !== undefined ? action.payload.currentOpening : state.currentOpening),
                listOfCandidates: (action.payload.listOfCandidates !== undefined ? state.listOfCandidates.concat(action.payload.listOfCandidates) : state.listOfCandidates),
                currentCandidate: (action.payload.currentCandidate !== undefined ? action.payload.currentCandidate : state.currentCandidate),
                otherOpeningsData: (action.payload.otherOpeningsData !== undefined ? action.payload.otherOpeningsData : state.otherOpeningsData),

                usersList: (action.payload.usersList !== undefined ? action.payload.usersList : state.usersList),
                currentCandidateChat: (action.payload.currentCandidateChat !== undefined ? action.payload.currentCandidateChat : state.currentCandidateChat),
                chatUploadingFilesStatus: (action.payload.chatUploadingFilesStatus !== undefined ? action.payload.chatUploadingFilesStatus : state.chatUploadingFilesStatus),

                followupFormData: (action.payload.followupFormData !== undefined ? action.payload.followupFormData : state.followupFormData),
                netxStageFromData: (action.payload.netxStageFromData !== undefined ? action.payload.netxStageFromData : state.netxStageFromData),
                currentApplication: (action.payload.currentApplication !== undefined ? action.payload.currentApplication : state.currentApplication),
                orgChartData: (action.payload.orgChartData !== undefined ? action.payload.orgChartData : state.orgChartData),
                stages: (action.payload.stages !== undefined ? action.payload.stages : state.stages),
                editedJoiningStage: (action.payload.editedJoiningStage !== undefined ? action.payload.editedJoiningStage : state.editedJoiningStage),
                editedQuestionData: (action.payload.editedQuestionData !== undefined ? action.payload.editedQuestionData : state.editedQuestionData),
                currentStageIndex: (action.payload.currentStageIndex !== undefined ? action.payload.currentStageIndex : state.currentStageIndex),
                momFormData: (action.payload.momFormData !== undefined ? action.payload.momFormData : state.momFormData),
                APIRequestList: (action.payload.APIRequestList !== undefined ? action.payload.APIRequestList : state.APIRequestList),
                envdata: (action.payload.envdata !== undefined ? action.payload.envdata : state.envdata),
                presetData: (action.payload.presetData !== undefined ? action.payload.presetData : state.presetData),

                notifications: (action.payload.notifications !== undefined ? action.payload.notifications : state.notifications),
                notificationLimit: (action.payload.notificationLimit !== undefined ? action.payload.notificationLimit : state.notificationLimit),
                notificationPageNo: (action.payload.notificationPageNo !== undefined ? action.payload.notificationPageNo : state.notificationPageNo),
                notificationNextpage: (action.payload.notificationNextpage !== undefined ? action.payload.notificationNextpage : state.notificationNextpage),
                recruitmentNotification: (action.payload.recruitmentNotification !== undefined ? action.payload.recruitmentNotification : state.recruitmentNotification),
                recruitmentNotificationLimit: (action.payload.recruitmentNotificationLimit !== undefined ? action.payload.recruitmentNotificationLimit : state.recruitmentNotificationLimit),
                recruitmentNotificationPageNo: (action.payload.recruitmentNotificationPageNo !== undefined ? action.payload.recruitmentNotificationPageNo : state.recruitmentNotificationPageNo),
                recruitmentNotificationNextpage: (action.payload.recruitmentNotificationNextpage !== undefined ? action.payload.recruitmentNotificationNextpage : state.recruitmentNotificationNextpage),
                searchItems: (action.payload.searchItems !== undefined ? action.payload.searchItems : state.searchItems),
                notificationCount: (action.payload.notificationCount !== undefined ? action.payload.notificationCount : state.notificationCount),
                recruitmentNotificationCount: (action.payload.recruitmentNotificationCount !== undefined ? action.payload.recruitmentNotificationCount : state.recruitmentNotificationCount),

                redirectPagename: (action.payload.redirectPagename !== undefined ? action.payload.redirectPagename : state.redirectPagename),
                redirectItem: (action.payload.redirectItem !== undefined ? action.payload.redirectItem : state.redirectItem),
                redirectFromNotification: (action.payload.redirectFromNotification !== undefined ? action.payload.redirectFromNotification : state.redirectFromNotification),

                reapproach: (action.payload.reapproach !== undefined ? action.payload.reapproach : state.reapproach),
                searchCandidate: (action.payload.searchCandidate !== undefined ? action.payload.searchCandidate : state.searchCandidate),
                announcements: (action.payload.announcements !== undefined ? action.payload.announcements : state.announcements),
                renderSubheaderRouter: (action.payload.renderSubheaderRouter !== undefined ? action.payload.renderSubheaderRouter : state.renderSubheaderRouter),
                // disableButton: (action.payload.disableButton !== undefined ? action.payload.disableButton : state.disableButton),
                headerAnnouncement: (action.payload.headerAnnouncement !== undefined ? action.payload.headerAnnouncement : state.headerAnnouncement),
                headerModal: (action.payload.headerModal !== undefined ? action.payload.headerModal : state.headerModal),

                globalTimer: (action.payload.globalTimer !== undefined ? action.payload.globalTimer : state.globalTimer),
                supportRating: (action.payload.supportRating !== undefined ? action.payload.supportRating : state.supportRating),
                assetAssign: (action.payload.assetAssign !== undefined ? action.payload.assetAssign : state.assetAssign),
                errorBatch: (action.payload.errorBatch !== undefined ? action.payload.errorBatch : state.errorBatch),
                deleteModalData: (action.payload.deleteModalData !== undefined ? action.payload.deleteModalData : state.deleteModalData),
                taskNotes: (action.payload.taskNotes !== undefined ? action.payload.taskNotes : state.taskNotes),
                taskComments: (action.payload.taskComments !== undefined ? action.payload.taskComments : state.taskComments),
                envConfig: (action.payload.envConfig !== undefined ? action.payload.envConfig : state.envConfig),
                bulkactionalias: (action.payload.bulkactionalias !== undefined ? action.payload.bulkactionalias : state.bulkactionalias),
                bulkactiondata: (action.payload.bulkactiondata !== undefined ? action.payload.bulkactiondata : state.bulkactiondata),
                approvalbulkactiondata: (action.payload.approvalbulkactiondata !== undefined ? action.payload.approvalbulkactiondata : state.approvalbulkactiondata),// for Approval in Bulk Action | Deep Dungarani  ~ 2025-11-04
                vacentSeatFilterData: (action.payload.vacentSeatFilterData !== undefined ? action.payload.vacentSeatFilterData : state.vacentSeatFilterData),
                vacentSeatRightSidebarFormData: (action.payload.vacentSeatRightSidebarFormData !== undefined ? action.payload.vacentSeatRightSidebarFormData : state.vacentSeatRightSidebarFormData),
                vacentSeatData: (action.payload.vacentSeatData !== undefined ? action.payload.vacentSeatData : state.vacentSeatData),
                vacentSeatFormData: (action.payload.vacentSeatFormData !== undefined ? action.payload.vacentSeatFormData : state.vacentSeatFormData),
                selectedNodeIndex: (action.payload.selectedNodeIndex !== undefined ? action.payload.selectedNodeIndex : state.selectedNodeIndex),
                globalTimerCompleteData: (action.payload.globalTimerCompleteData !== undefined ? action.payload.globalTimerCompleteData : state.globalTimerCompleteData),

                detailModalData: (action.payload.detailModalData !== undefined ? state.detailModalData.concat(action.payload.detailModalData) : state.detailModalData),
                detailModalFieldOrder: (action.payload.detailModalFieldOrder !== undefined ? action.payload.detailModalFieldOrder : state.detailModalFieldOrder),
                detailModalNewFieldOrder: (action.payload.detailModalNewFieldOrder !== undefined ? action.payload.detailModalNewFieldOrder : state.detailModalNewFieldOrder),
                detailModalNextpage: (action.payload.detailModalNextpage !== undefined ? action.payload.detailModalNextpage : state.detailModalNextpage),
                detailModalPageNo: (action.payload.detailModalPageNo !== undefined ? action.payload.detailModalPageNo : state.detailModalPageNo),
                detailModalPagelimit: (action.payload.detailModalPagelimit !== undefined ? action.payload.detailModalPagelimit : state.detailModalPagelimit),
                detailModalPageName: (action.payload.detailModalPageName !== undefined ? action.payload.detailModalPageName : state.detailModalPageName),
                detailModalSortData: (action.payload.detailModalSortData !== undefined ? action.payload.detailModalSortData : state.detailModalSortData),
                detailModalFilterData: (action.payload.detailModalFilterData !== undefined ? action.payload.detailModalFilterData : state.detailModalFilterData),
                detailModalOldFilterData: (action.payload.detailModalOldFilterData !== undefined ? action.payload.detailModalOldFilterData : state.detailModalOldFilterData),
                detailModalMasterData: (action.payload.detailModalMasterData !== undefined) ? action.payload.detailModalMasterData : state.detailModalMasterData,
                detailModalMasterDataList: (action.payload.detailModalMasterDataList !== undefined) ? action.payload.detailModalMasterDataList : state.detailModalMasterDataList,
                bizConfigData: (action.payload.bizConfigData !== undefined) ? action.payload.bizConfigData : state.bizConfigData,
                redirectFromConfigration: (action.payload.redirectFromConfigration !== undefined) ? action.payload.redirectFromConfigration : state.redirectFromConfigration,
                ZOOM_CLIENT_ID: (action.payload.ZOOM_CLIENT_ID !== undefined) ? action.payload.ZOOM_CLIENT_ID : state.ZOOM_CLIENT_ID, //Aniket 21/04/2025
                META_CLIENTID: (action.payload.META_CLIENTID !== undefined) ? action.payload.META_CLIENTID : state.META_CLIENTID,
                GOOGLE_CLIENT_ID: (action.payload.GOOGLE_CLIENT_ID !== undefined) ? action.payload.GOOGLE_CLIENT_ID : state.GOOGLE_CLIENT_ID, //Aniket 21/04/2025
                WP_CLIENTID: (action.payload.WP_CLIENTID !== undefined) ? action.payload.WP_CLIENTID : state.WP_CLIENTID,
                WP_CONFIGID: (action.payload.WP_CONFIGID !== undefined) ? action.payload.WP_CONFIGID : state.WP_CONFIGID,
                GOOGLE_FONTS_API_KEY: (action.payload.GOOGLE_FONTS_API_KEY !== undefined) ? action.payload.GOOGLE_FONTS_API_KEY : state.GOOGLE_FONTS_API_KEY,
                MICROSOFT_CLIENT_ID: (action.payload.MICROSOFT_CLIENT_ID !== undefined) ? action.payload.MICROSOFT_CLIENT_ID : state.MICROSOFT_CLIENT_ID, //Aniket 21/04/2025
                MICROSOFT_TENANT_ID: (action.payload.MICROSOFT_TENANT_ID !== undefined) ? action.payload.MICROSOFT_TENANT_ID : state.MICROSOFT_TENANT_ID, //Aniket 21/04/2025
                META_CLIENTSECRET: (action.payload.META_CLIENTSECRET !== undefined) ? action.payload.META_CLIENTSECRET : state.META_CLIENTSECRET,
                tagValidationsModal: (action.payload.tagValidationsModal !== undefined ? action.payload.tagValidationsModal : state.tagValidationsModal), //  smit surani  ~ 2025-06-30 ~ 12:39 PM
                fileuploads: (action.payload.fileuploads !== undefined ? action.payload.fileuploads : state.fileuploads), // ~ Utsav
                filedownloads: (action.payload.filedownloads !== undefined ? action.payload.filedownloads : state.filedownloads), // ~ Utsav

            }

        case 'clearTimerData':
            return {
                ...state,
                timerdata: []
            }
        case 'clearData':
            return {
                ...state,
                data: []
            }
        case 'clearDetailsModalData':
            return {
                ...state,
                detailModalData: []
            }
        case 'clearApplicationData':
            return {
                ...state,
                applicationData: [],
                listOfCandidates: []
            }

        case 'setApplicationData':
            return {
                ...state,
                applicationData: action.payload.applicationData
            }

        case 'setListOfCandidates':
            return {
                ...state,
                listOfCandidates: action.payload.listOfCandidates
            }
        case 'clearmasterData':
            return {
                ...state,
                masterData: []
            }
        case 'clearsearchResultArray':
            return {
                ...state,
                searchResultArray: []
            }
        case 'clearWhatsAppChatData':
            return {
                ...state,
                currentCandidateChat: []
            }
        case 'clearWhatsAppListData':
            return {
                ...state,
                usersList: [],
            }
        case 'updateData':
            return {
                ...state,
                data: (action.payload.data !== undefined) ? action.payload.data : state.data,
                envdata: (action.payload.envdata !== undefined) ? action.payload.envdata : state.envdata
                // data : (action.payload.data !== undefined ? state.data.concat(action.payload.data) : state.data)
            }
        case 'updatesearchResultArray':
            return {
                ...state,
                searchResultArray: (action.payload.searchResultArray !== undefined) ? action.payload.searchResultArray : state.searchResultArray
            }

        case 'setCookiesData':
            return {
                ...state,
                cookiesData: (action.payload.cookiesData !== undefined) ? action.payload.cookiesData : state.cookiesData
            }

        case 'setLocalStorageData':
            return {
                ...state,
                localStorageData: (action.payload.localStorageData !== undefined) ? action.payload.localStorageData : state.localStorageData
            }

        // used in announcement controller
        case 'setGridListData':
            return {
                ...state,
                data: action.payload.data
            }

        case 'setDetailsModalGridListData':
            return {
                ...state,
                detailModalData: action.payload.detailModalData
            }

        case 'setUserRights':
            return {
                ...state,
                userRights: action.payload.userRights
            }

        // do not stage ~ Nirzar Gabani
        case 'setWidgetRights':
            return {
                ...state,
                widgetRights: action.payload.widgetRights
            }

        case 'setMenuData':
            return {
                ...state,
                menuData: action.payload.menuData
            }
        case 'setAliasData':
            return {
                ...state,
                aliasData: action.payload.aliasData
            }
        case 'setLoading':
            return {
                ...state,
                loading: action.payload.loading,
            }
        case 'setLoadings':
            return {
                ...state,
                loadings: action.payload.loadings
            }

        default:
            return state
    }
}

export default appReducer